// extracted by mini-css-extract-plugin
export default {"tips":"index_tips_vqxNj"};